export type ILineData = {
  timestamp: number;
  value: number;
};

const timestampsArray = [
  1624453280000, 1624366880000, 1624280480000, 1624194080000, 1624107680000, 1624021280000,
  1623934880000, 1623848480000, 1623762080000, 1623675680000, 1623589280000, 1623502880000,
  // 1623416480000, 1623330080000, 1623243680000, 1623157280000, 1623070880000, 1622984480000,
  // 1622898080000, 1622811680000, 1622725280000, 1622638880000, 1622552480000, 1622466080000,
].reverse();

const valuesArr = [
  330609, 36070, 84019, 365639, 127576, 156922, 235355, 153966, 44021, 199302, 32172, 298200,
  // 377249, 409304, 92751, 273331, 68965, 112677, 46016, 269418, 140628, 112563, 285447, 351130,
];

export const lineValues: ILineData[] = Array(valuesArr.length)
  .fill(0)
  .map((d, i) => {
    return { timestamp: timestampsArray[i], value: valuesArr[i] };
  });
